<div style="height: 90vh; background-color: lightblue;">
    <input type="text" [(ngModel)]="dummyText">
    <button (click)="submitText()">Submit</button>
</div>